var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommunity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1638:4533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2628 5.44417C27.2628 6.31228 27.0107 7.16096 26.5385 7.88266C26.0662 8.60436 25.395 9.1667 24.6098 9.49853C23.8246 9.83037 22.9607 9.91664 22.1274 9.74669C21.2941 9.57674 20.5289 9.15822 19.9286 8.54381C19.3283 7.92939 18.92 7.14678 18.7552 6.29515C18.5903 5.44352 18.6765 4.56103 19.0028 3.75946C19.3291 2.95789 19.8808 2.27331 20.588 1.79218C21.2953 1.31106 22.1264 1.05504 22.9761 1.05665C23.5397 1.05665 24.0978 1.1702 24.6184 1.39079C25.139 1.61138 25.6119 1.93462 26.0101 2.34215C26.4082 2.74967 26.7238 3.23354 26.9388 3.76581C27.1538 4.29808 27.2639 4.86838 27.2628 5.44417Z",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7002 50.984L28.1058 33.832C29.6964 33.247 31.5654 31.9064 31.3983 30.2083L30.1099 17.1514C30.0104 16.315 29.6183 15.5436 29.0059 14.9793C28.3936 14.4149 27.6022 14.0955 26.7777 14.0801H19.2144C18.3903 14.0972 17.5998 14.4172 16.9878 14.9812C16.3758 15.5453 15.9833 16.3156 15.8821 17.1514L14.5937 30.2083C14.4267 31.9064 16.3115 33.247 17.8862 33.832L18.2998 50.984",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5301 6.37891C38.2839 6.37731 39.0212 6.60427 39.6487 7.03094C40.2762 7.4576 40.7657 8.06494 41.0553 8.77595C41.3448 9.48695 41.4214 10.2697 41.2753 11.0252C41.1292 11.7807 40.767 12.4749 40.2346 13.02C39.7021 13.5651 39.0234 13.9365 38.2842 14.0874C37.545 14.2382 36.7786 14.1615 36.0821 13.8672C35.3855 13.5728 34.7901 13.0742 34.3711 12.434C33.9522 11.7938 33.7286 11.0409 33.7286 10.2708C33.7286 9.24004 34.1288 8.25133 34.8415 7.52169C35.5542 6.79206 36.5211 6.38107 37.5301 6.37891Z",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7054 50.9843L42.0712 35.7581C43.471 35.2381 45.1411 34.0437 44.99 32.5081L43.8527 20.9218C43.7632 20.1787 43.4151 19.4932 42.872 18.9905C42.3288 18.4879 41.6269 18.2014 40.8942 18.1836H34.5318",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46195 6.37891C7.70851 6.37891 6.97199 6.60726 6.34553 7.03491C5.71906 7.46255 5.23079 8.07036 4.94246 8.7815C4.65413 9.49265 4.57868 10.2752 4.72567 11.0302C4.87266 11.7851 5.23549 12.4786 5.76825 13.0229C6.30101 13.5672 6.9798 13.9378 7.71877 14.0879C8.45773 14.2381 9.22369 14.1611 9.91978 13.8666C10.6159 13.572 11.2108 13.073 11.6294 12.433C12.048 11.793 12.2714 11.0406 12.2714 10.2708C12.2725 9.75943 12.1747 9.25298 11.9836 8.78031C11.7925 8.30765 11.512 7.87814 11.158 7.51653C10.804 7.15493 10.3837 6.86829 9.92101 6.67309C9.45835 6.47788 8.96252 6.37784 8.46195 6.37891V6.37891Z",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28665 50.9843L3.92877 35.7581C2.52905 35.2381 0.850965 34.0437 1.00207 32.5081L2.1473 20.9218C2.23521 20.178 2.58282 19.4916 3.1263 18.9886C3.66978 18.4856 4.37265 18.1997 5.10581 18.1836H11.4682",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1638:4533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 52,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.d1ad17ed.svg";
export { ForwardRef as ReactComponent };